
import eService from "../services/eServiceDataService";

export default {
  name: 'DirectorySearch',
  watch: {
    '$store.state.language': function() {
      this.lang = this.$store.state.language;
      this.updateData();
    }
  },
  created() {
    this.loading = true;
    document.title = "Manulife Insurances Directory";

    this.env = this.$store.state.env;
  },
  computed: {

  },
  mounted: async function () {

    await eService.getManulifeMappingFile().then(res => {
      //console.log(res.data);
      this.apiData = res.data;
      this.updateData();
      this.loading = false;
    }).catch(e => {
      console.log(e);
    });

  },
  data () {
    return {
      env : '',
      separator: 'vertical',
      filter: '',
      pagination: {
        page: 0,
        rowsPerPage: 0
      },
      columns: [],
      apiData : [],
      data: [],
      source : {},
      lang : this.$store.state.language,
      loading: false,
      errorDialog: false,
      errorMessage: "",
      errorDialogBtn: "",
      title : "",
      pageCookie : JSON.parse(localStorage.getItem('pages'))
    }
  },
  methods: {
    hover(rowIndex, props){
      this.leave();
      var hoverClass = document.getElementsByClassName('qtd-'+props);
      for(var j = 0; j < hoverClass.length; j++)
      {
        if(j !== rowIndex) {
          hoverClass[j].className += " qHover";
        }
      }
      if( typeof hoverClass[rowIndex] !== 'undefined') {
        hoverClass[rowIndex].className += " qFocus";
      }
    },
    leave(){
      var allQtd = document.getElementsByClassName('allQtd');
      for(var i = 0; i < allQtd.length; i++)
      {
        allQtd[i].classList.remove("qHover");
        allQtd[i].classList.remove("qFocus");
      }
    },
    readDoc(pdf){

      //var path = (process.env.VUE_APP_ENV === 'prod' ? '/' : (process.env.VUE_APP_ENV === 'local' ? '/' : '/'))
      var pdfUrl = './pdf/manulife/'+pdf+'.pdf';

      var xhr = new XMLHttpRequest()
      xhr.open('HEAD', pdfUrl, false)
      xhr.send()

      if(xhr.status == '404'){
        alert('File is not existed. Please help to check with IT')
      }else{
        //this.$router.push({ name: 'ReadPDF', params: { pdf: pdfUrl } })
        window.open(pdfUrl, '_blank')
      }

    },
    updateData(){

      var currentLang = this.lang;
      var insurances = this.apiData.insurances.recordset;
      var insurance_item = [];
      var plans = this.apiData.plans.recordset;
      var planGrp = {};

      var insuranceCol = [
        {
          name : "plans",
          field : "plans",
          label : '',
          align: 'center',
          sortable: true
        }
      ];

      insurances.forEach(item => {
        insuranceCol.push(
            {
              name : item.insurance_id,
              field : item.insurance_id,
              label : item['name_'+currentLang],
              align: 'center',
              sortable: true
            }
        )
        insurance_item.push(item.insurance_id);
      });

      this.columns = insuranceCol;

      plans.forEach(el => {
        if(!Object.prototype.hasOwnProperty.call(planGrp, el.planID)) {
          planGrp[el.planID] = [];
        }
        planGrp[el.planID].push(el);
      });


      var plansEle = [];
      Object.keys(planGrp).forEach(key => {
        var obj = {};
        obj.plans = planGrp[key][0]["planName"+currentLang.toUpperCase()];
        obj.planID = planGrp[key][0]["planID"];

        planGrp[key].forEach(pl => {
          obj[pl.inID] = pl.pdf
        });

        plansEle.push(obj);
      });

      //console.log("----------------");
      //console.log(planGrp)

      this.source = planGrp;
      this.data = plansEle;

      this.title = (this.pageCookie)[2]["name_"+this.lang];
    }
  }
}
